<template>
  <div class="password-validator">
    <slot></slot>
    <div class="validator-dropdown" ref="dropdown" v-show="$props.visible">
      <transition name="slide" mode="out-in">
        <div class="dropdown-container" v-if="$props.visible">
          <h5 class="title">{{ $t('passwordValidationDropdown.title') }}</h5>
          <ul class="password-rules">
            <li :class="minLength ? 'error' : 'pass'">
              <i :class="minLength ? 'icon-close' : 'icon-check'"></i>
              {{ $t('passwordValidationDropdown.minLength') }}
            </li>
            <li :class="uppercaseLetter ? 'error' : 'pass'">
              <i :class="uppercaseLetter ? 'icon-close' : 'icon-check'"></i>
              {{ $t('passwordValidationDropdown.uppercaseLetter') }}
            </li>
            <li :class="lowercaseLetter ? 'error' : 'pass'">
              <i :class="lowercaseLetter ? 'icon-close' : 'icon-check'"></i>
              {{ $t('passwordValidationDropdown.lowercaseLetter') }}
            </li>
            <li :class="specialCharOrNum ? 'error' : 'pass'">
              <i :class="specialCharOrNum ? 'icon-close' : 'icon-check'"></i>
              {{ $t('passwordValidationDropdown.specialCharOrNum') }}
            </li>
          </ul>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'validate-password-dropdown',
  props: {
    password: String,
    visible: Boolean
  },
  computed: {
    minLength () {
      return this.$props.password.length < 7
    },
    uppercaseLetter () {
      const uppercaseRegex = new RegExp('(?=.*[A-Z])')
      return !uppercaseRegex.test(this.$props.password)
    },
    lowercaseLetter () {
      const lowercaseRegex = new RegExp('(?=.*[a-z])')
      return !lowercaseRegex.test(this.$props.password)
    },
    specialCharOrNum () {
      const regex = new RegExp('((?=.*[0-9])|(?=.*[~"\'!@#$%^&*]))')
      return !regex.test(this.$props.password)
    }
  }
}
</script>

<style scoped lang="scss">
.password-validator {
  position: relative;
}

.validator-dropdown {
  position: absolute;
  top: calc(100% - 1rem);
  z-index: 99;
  display: block;
  width: 100%;
  max-width: 400px;

  .dropdown-container {
    background-color: $white;
    padding: 2rem 1.6rem;
    box-shadow: 2px 0 20px 0 rgba(0, 0, 0, 0.16);
    border-radius: .5rem;
    text-align: left;
    position: relative;

    &:before {
      position: absolute;
      top: -1.2rem;
      left: .8rem;
      border-left: 1.2rem solid transparent;
      border-right: 1.2rem solid transparent;
      border-bottom: 1.2rem solid $white;
      width: 0;
      height: 0;
      content: '';
    }

    .title {
      font-size: 1.2rem;
      font-weight: 600;
      color: $light-black;
      margin-bottom: .8rem;
    }

    .password-rules {
      padding: 0;
      margin: 0;
      list-style: none;

      li {
        font-size: 1.2rem;
        line-height: 2.5;
        vertical-align: middle;

        i {
          margin-right: 1.4rem;
          vertical-align: middle;
        }

        &.error {
          color: $error;

          i {
            font-size: 1.1rem;
          }
        }

        &.pass {
          color: $success;
        }
      }
    }
  }
}
</style>
